import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

interface BannerTextProps {
  $hasHighPriority: boolean;
}

export const Banner = styled(Box)<BannerTextProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 8px;
  margin-left: 0;
  background-color: #ece5ba;
  cursor: pointer;
  text-decoration: underline;
  position: fixed;
  top: 0;
  z-index: 200;

  ${(props) => (props.$hasHighPriority ? 'background-color: #EAB3AE;' : 'background-color: #ECE5BA;')}

  Svg {
    padding-right: 4px;
  }
`;
